import React from 'react';
import { makeStyles } from '@mui/styles';
import { Alert } from '@mui/material';
import PropTypes from 'prop-types';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: '100%',
//     '& > * + *': {
//       marginTop: theme.spacing(2),
//     },
//   },
// }));

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    '& > * + *': {
      // marginTop: theme.spacing(2),
    },
  },
}));


// interface WarningAlertProps {
//   alertMessage:PropTypes.func

// }



 export const WarningAlert=(props) =>{



WarningAlert.propTypes={

    alertMessage:PropTypes.func,
    displayAlert:PropTypes.func
 }



  const classes = useStyles();
  
 
  const message=props.alertMessage;

 if(props.displayAlert) {
  return (
    <div className={classes.root}>
      <Alert variant="outlined" severity="warning">
        {message}
      </Alert>
    </div>
  ) 

 }


 return(

	<div>
		</div>
 )

  
	}